import { NgModule } from '@angular/core';
import { CommonModule, registerLocaleData } from '@angular/common';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from "@angular/common/http";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { FormsModule } from '@angular/forms';

import fr from "@angular/common/locales/fr";
import en from "@angular/common/locales/en";
import pt from "@angular/common/locales/pt";
import ar from "@angular/common/locales/ar";

import { SlickCarouselModule } from 'ngx-slick-carousel';
import { IConfig, NgxMaskDirective, NgxMaskPipe, provideNgxMask } from "ngx-mask";
import { NgxStripeModule } from 'ngx-stripe';

import { LottieModule } from 'ngx-lottie';
import player from 'lottie-web';

// import { TwitchLoginSdkModule } from "twitch-login-sdk";

import { ApiCallsInterceptor } from './_interceptors/api-calls.interceptor';
import { CallInterceptor } from 'projects/authentication/_interceptors/call.interceptor';

import { HeaderComponent } from '../components/header/header.component';
import { FooterComponent } from '../components/footer/footer.component';
import { GroupByPipe } from './_pipe/group-by.pipe';

registerLocaleData(fr);
registerLocaleData(en);
registerLocaleData(pt);
registerLocaleData(ar);

export function playerFactory() { return player }

const maskConfig: Partial<IConfig> = { validation: false };

@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    GroupByPipe
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    SlickCarouselModule,
    FormsModule,
    NgxMaskDirective,
    NgxMaskPipe,
    NgxStripeModule.forRoot('pk_live_51IDS5mEkX2DSmz9GxBZLUz6MFCUTltsDqolhHy3pNnEx7BdlIPEFRb7gqYa0TuPg9NFJeEJjzR5iqOC76uifPupv00ly6uTB2A'),
    // NgxStripeModule.forRoot('pk_test_51IDS5mEkX2DSmz9GTwqfqyj0PrhfxqNJTtmWhlC90oSQ2iT1sjmqAMB0ugg6Zw53lM1saCHnoX3RHQEBteWtiwvn00umpBAX8D'),
    LottieModule.forRoot({ player: playerFactory }),
    /* TwitchLoginSdkModule.forRoot({
      twitchId: '',
      redirect: `${window.location.protocol}//${window.location.hostname}:${window.location.port}/login`
    }) */
  ],
  exports: [
    CommonModule,
    HttpClientModule,
    TranslateModule,
    SlickCarouselModule,
    FormsModule,
    HeaderComponent,
    FooterComponent,
    NgxMaskDirective,
    NgxMaskPipe,
    NgxStripeModule,
    GroupByPipe,
    LottieModule,
    // TwitchLoginSdkModule
  ],
  providers: [
    GroupByPipe,
    provideNgxMask(maskConfig),
    { provide: HTTP_INTERCEPTORS, useClass: ApiCallsInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: CallInterceptor, multi: true }
  ]
})
export class SharedModule { }

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
  // return new TranslateHttpLoader(http, `/product-conf/${location.hostname},upar/object/langs.`, '/plain');
}